<script lang="ts">
    
    import { onMount, onDestroy, getContext } from 'svelte';
    import type { Readable } from 'svelte/store';
    import type { RegisterValidationState, UnregisterValidationState } from '../global';
    import { State } from '../Model/State';

    export let override: any = undefined;

    const validityState = new State(true);

    let container: HTMLElement;
    let control: HTMLInputElement;
    let focus = false;
    let input = false;
    let valueMissing = false;
    let tooShort = false;
    let typeMismatch = false;
    let empty = true;
    let valid = true;
    let invalid = false;
    
    const registerValidationState: RegisterValidationState = getContext('registerValidationState');
    const unregisterValidationState: UnregisterValidationState = getContext('unregisterValidationState');
    const forceInput: Readable<boolean> = getContext('forceInput');

    $: updateOverride(override);
    $: if ($forceInput) {
        input = true;
    }

    registerValidationState?.(validityState);
    
    onMount(() => {
        control = container.querySelector('input, select');
        control.addEventListener('focus', onFocus);
        control.addEventListener('input', onInput);
        control.addEventListener('change', onInput);
        updateValidity();
    });
    
    onDestroy(() => {
        unregisterValidationState?.(validityState);
    });

    function updateOverride(override: any): void {
        if (override !== undefined) {
            $validityState = !!override;
        }
        updateValidity();
    }

    function onFocus() {
        focus = true;
    }

    function onInput() {
        input = true;
        updateValidity();
    }

    function updateValidity() {
        if (!control) {
            return;
        }
        const { validity }  = control;
        valueMissing = validity.valueMissing;
        tooShort = validity.tooShort;
        typeMismatch = validity.typeMismatch;
        empty = !control.value;
        valid = override === undefined ? validity.valid : !!override;
        invalid = !valid;
        $validityState = valid;
    }
    
</script>

<div bind:this={container} style="display: contents;">
    <slot
        {control}
        {valueMissing}
        {tooShort}
        {typeMismatch}
        {focus}
        {input}
        {empty}
        {valid}
        {invalid} />
</div>


